module.exports = __webpack_public_path__ + "assets/ebike_dark.79e1286d.svg";